/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-74df9b0a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ql-editor"
};
const _hoisted_2 = ["innerHTML"];
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    const dialogVisible = ref(false);
    const content = ref('');
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const show = _content => {
      dialogVisible.value = true;
      content.value = _content;
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_dialog = __unplugin_components_0;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "参数配置说明",
        width: "900px",
        "before-close": handleClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
          class: "ql-container content",
          innerHTML: decodeURIComponent(_unref(content))
        }, null, 8, _hoisted_2)])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});